module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_112_5.c6ca4f76.pdf";